/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48aeda30986e19ad7fa773fc21fe5bb7>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "GrowVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-vertical
 * Usage guidance:
 * Single purpose - Reserved for increasing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const GrowVerticalIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "GrowVerticalIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.47 15.78-3.5-3.5 1.06-1.06 2.22 2.22V9h1.5v4.44l2.22-2.22 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0M7.25 2.56 5.03 4.78 3.97 3.72l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06-2.22-2.22V7h-1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
GrowVerticalIcon.displayName = 'GrowVerticalIcon';
var _default = exports.default = GrowVerticalIcon;